import { render, staticRenderFns } from "./swiper_in.vue?vue&type=template&id=f2a8fd42&scoped=true"
import script from "./swiper_in.vue?vue&type=script&lang=js"
export * from "./swiper_in.vue?vue&type=script&lang=js"
import style0 from "./swiper_in.vue?vue&type=style&index=0&id=f2a8fd42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a8fd42",
  null
  
)

export default component.exports